export default __webpack_public_path__ + "static/media/gallery_08.68273f2a.jpg";